<template>
  <div class="songs--container">
      <data-container>
        <template #controls>
                <AppDropdown
                    v-model="filter.sort_by"
                    :options="sortItems"
                    :disabled="isLoading"
                    @input="getSubscriptions"
                >
                    Sort by
                </AppDropdown>
                <!-- <AppDropdown class="theme-filter"
                    v-model="filter.theme_filter"
                    :options="themeItems"
                    :disabled="isLoading"
                    :checkbox="true"
                    :multiple="true"
                    @input="() => {
                        filter.page = 1
                        getSubscriptions()
                    }"
                >
                    Theme Filter
                </AppDropdown> -->

                <div class="right--controls">
                    <!-- <AppButton
                        :disabled="isLoading"
                        modifier="small-primary"
                    >
                        Add Subscription
                    </AppButton> -->
                    <AppTextField
                        v-model.trim="filter.keyword"
                        placeholder="Type here"
                        icon-right="search"
                        @input="search"
                    />
                </div>
        </template>
        <template #content>
            <AppTable
                :dataset="subscriptionList.data"
                :fields="fields"
                :selected="selectedItems"
                :loading="isLoading"
                @select="selectedItems = $event"
                @endOfScroll="message('end of scroll')"
                :total-count="subscriptionList.total"
                :current-page="parseInt(filter.page)"
                :items-per-page="parseInt(filter.count)"
                @changePage="changePage"
            >
                <template #price="{ props }">
                    {{ props.item.price || '--' }}
                </template>
                <template #currency="{ props }">
                    {{ props.item.currency.toUpperCase() }}
                </template>
                <template #billing_cycle="{ props }">
                    {{ props.item.billing_cycle.toUpperCase() }}
                </template>
                <template #created_at="{ props }">
                    {{ props.item.created_at | dateFormatter }}
                </template>
                <!-- <template #action="{ props }">
                    <div class="actions">
                        <AppButton modifier="icon small-primary">
                            <img src="@/assets/img/ic-edit.svg" class="icon" @click="view(props.item)">
                        </AppButton>
                        <AppButton modifier="icon small-danger" @click="confirmRemove(props.item)">
                            <img src="@/assets/img/ic-trash.svg" class="icon">
                        </AppButton>
                    </div>
                </template> -->
            </AppTable>
        </template>
    </data-container>
  </div>
</template>

<script>
import DataContainer from '@/components/DataContainer'
import AppDropdown from '@/components/AppDropdown'
// import AppButton from '@/components/AppButton'
import AppTextField from '@/components/AppTextField'
import AppTable from '@/components/AppTable'
import subscription from '@/store/subscription/app.js'
import { subscriptionFields, sortItems, themeItems } from '@/utils/meta.js'
import { setQueryParams } from '@/utils/helpers.js'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
	data () {
		return {
			sort: '',
			selectedItems: [],
			fields: subscriptionFields,
			themeItems: themeItems
		}
	},

	methods: {
		search (val) {
			this.filter.page = 1
			this.filter.keyword = val
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.getSubscriptions()
			}, 300)
		},

		getSubscriptions () {
		    const query = { ...this.filter }
			Object.keys(query).forEach(key => {
				!query[key] && (delete query[key])
			})
			query.theme_filter && (query.theme_filter = query.theme_filter.join('|'))
			this.$router.push({ query })
			const queryStr = setQueryParams(this.filter)
		    this.$store.dispatch('subscription/list', queryStr.toLowerCase())
		},

		changePage ({ currentPage, itemsPerPage }) {
			this.filter.page = currentPage
			itemsPerPage !== this.filter.count && (this.filter.page = 1)
			this.filter.count = itemsPerPage
			this.getSubscriptions()
		},

		removeSong () {
		},

		view ({ id }) {
		}
	},

	computed: {
		...mapGetters('subscription', [
			'subscriptionList',
			'isLoading'
		]),
		...mapFields('subscription', [
			'filter'
		]),
		sortItems () { return sortItems },
		songPageCounter () {
			const { to, from } = this.subscriptionList
			return `${from || 0} - ${to || 0}`
		}
	},

	created () {
		const query = { ...this.$route.query }
		if (Object.keys(query).length) {
			Object.keys(query).forEach(key => {
				if (query[key] && key === 'theme_filter') {
					query[key] = query[key].split('|')
				} else {
					!query[key] && (delete query[key])
				}
			})
			this.filter = { ...query }
		}
		this.getSubscriptions()
	},

	beforeCreate () {
		if (!this.$store.hasModule('subscription')) {
			this.$store.registerModule('subscription', subscription)
		}
	},
	components: {
		DataContainer,
		AppDropdown,
		// AppButton,
		AppTextField,
		AppTable
	}
}
</script>

<style lang="scss" scoped>
.songs--container {
    padding: 1.5em;
}
.app-dropdown {
    min-width: 120px;
}

.custom-table {
    margin-top: 12px;
}

.theme-filter {
    margin-left: 8px ;
}

.right--controls{
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;

    .app-button--small-primary {
        margin-right: 12px;
    }
}

/deep/ .app-popup {
    width: 30em;
    padding: 16px 0;
}

.app-count-picker {
    margin-right: 5px;
}

.pagination--counter {
    display: flex;
    flex: 1;
    font-size: 1.2em;
}
</style>
